import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "src/apps/hooks/useAuth";
import { DOCUMENTATION_AREA_ROUTES } from "../Navigation";

interface AuthenticationRedirectProps {
  children: ReactNode;
}

export const AuthenticationRedirect = ({ children }: AuthenticationRedirectProps) => {
  const { token } = useAuth();

  if (!token) return <>{children}</>;

  return <Navigate to={`${DOCUMENTATION_AREA_ROUTES.HOME}${location.search}`} />;
};
